import React, { ReactNode } from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';
import { Box, LinearProgress } from '@mui/material';

import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';

import { NavigationBar, Page, PageContent, SizingMultiplier, PoweredByWatermark, Typography } from '@ocx/ui';

import { messages } from './store-locator.messages';

type LocalOffersLocationSelectorPageLayoutProps = {
  children: ReactNode;
  isLoading: boolean;
};

export const LocalOffersLocationSelectorPageLayout: React.FC<LocalOffersLocationSelectorPageLayoutProps> = ({
  children,
  isLoading,
}) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'localOffersStoreSelector:htmlTitle',
          defaultMessage: 'Local Offers Store Selector',
          description: 'HTML title tag for Local Offers Store Selector Page',
        })}
      />

      <NavigationBar
        left={<BackButton />}
        center={
          <Typography component="h2" variant="h6">
            <FormattedMessage {...messages['localOffers:searchPage:headerTitle']} />
          </Typography>
        }
      />

      <PageContent>
        <Box m={SizingMultiplier.md}>{children}</Box>

        <PoweredByWatermark />
      </PageContent>
      {isLoading && <LinearProgress sx={{ opacity: 0.8 }} />}
    </Page>
  );
};
